import { TableComment } from "../../../../general/src/TableComment";
import { TableContact } from "../../../../general/src/TableContact";
import { TableProfile } from "../../../../general/src/TableProfile";
import { CurrentDispatchStops } from "../CurrentDispatchStops";
import { DriverFuelCard } from "../DriverFuelCard";
import { DriverImage } from "../DriverImage";
import { TableEquipmentAlerts } from "../TableEquipmentAlerts";
import { TableEquipmentIssued } from "../TableEquipmentIssued";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriver extends Layout {
    PanelOpRight: Panel;
    buttonDriverAdvance: Button;
    buttonDriverUsers: Button;
    buttonMakePayee: Button;
    buttonOpenClassic: Button;
    checkboxAllowTrailerDrop: Checkbox;
    checkboxChoiceExcludeHazmat: Checkbox;
    checkboxDisableFeasibility: Checkbox;
    checkboxDisableRemoteAccess: Checkbox;
    checkboxExcludeCommodity: Checkbox;
    checkboxExcludeCustomer: Checkbox;
    checkboxExcludeEquipType: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeRevenue: Checkbox;
    checkboxPersonalConveyance: Switch;
    checkboxYardMove: Switch;
    citystateCityIdSearch: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelAddress: Label;
    labelCityStateZip: CityState;
    labelFullName: Label;
    labelLaneExclusions: Label;
    labelMovementDistance: Label;
    labelMovementDistanceCaption: Label;
    labelMovementDistanceUm: Label;
    labelNoDispatchInfo: Label;
    labelOrder: Label;
    labelOrderId: Label;
    labelPreassignment: Label;
    labelPreassignmentCaption: Label;
    layoutAttachment: DriverImage;
    layoutCurrentDispatchStops: CurrentDispatchStops;
    layoutDriverFuelCard: DriverFuelCard;
    layoutEquipmentIssued: TableEquipmentIssued;
    layoutImageTable: Layout;
    layoutProfileTable: TableProfile;
    layoutTableComment: TableComment;
    layoutTableContact: TableContact;
    layoutTableEquipmentAlerts: TableEquipmentAlerts;
    panelAdditionalInfo: Panel;
    panelCurrentDispatchHeader: Panel;
    panelCurrentDispatchSearch: Panel;
    panelDataHeader: DataHeader;
    panelDates: Panel;
    panelDispatchLineOne: Panel;
    panelDispatchLineTwo: Panel;
    panelDriverImage: Panel;
    panelDriverInfo: Panel;
    panelHeaderDriver: Panel;
    panelLaneExclusions: Panel;
    panelLoadMatch: Panel;
    panelLoadMatchCheckboxes: Panel;
    panelLoadMatchPriorityTextboxes: Panel;
    panelLogixSolution: Panel;
    panelMoveDistance: Panel;
    panelOpLeft: Panel;
    panelOpMid: Panel;
    panelOpSecrets: Panel;
    panelOpToggles: Panel;
    panelOperations: Panel;
    panelOrderId: Panel;
    panelOrderLine: Panel;
    panelPayee: Panel;
    panelPreassignment: Panel;
    panelRegDates1: Panel;
    panelRegDates2: Panel;
    panelRegDates3: Panel;
    panelSearchContent: Panel;
    panelStopDetailsSearch: Panel;
    sourceAgencyLink: DataSource;
    sourceAutoHomeHistory: DataSource;
    sourceAutoHomeLocation: DataSource;
    sourceCargoClaim: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceDriver: DataSource;
    sourceDriverImage: DataSource;
    sourceDriverLane: DataSource;
    sourceDriverMiles: DataSource;
    sourceEquipmentIssued: DataSource;
    sourceFuelCardDriverList: DataSource;
    sourceMotoraccident: DataSource;
    sourceOsd: DataSource;
    sourceProfiles: DataSource;
    sourceServicefail: DataSource;
    sourceUnitMessage: DataSource;
    switchDisableLoadMatch: Switch;
    switchDoublesCertified: Switch;
    switchHazmatCert: Switch;
    switchIsActive: Switch;
    switchMedicalExempt: Switch;
    switchMpwExclude: Switch;
    switchRehire: Switch;
    switchTankEndorsement: Switch;
    switchType: Switch;
    tabAccidents: Tab;
    tabAutoHome: Tab;
    tabAutoHomeHistory: Tab;
    tabAutoHomeLocation: Tab;
    tabClaims: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabDates: Tab;
    tabDispatch: Tab;
    tabDriverMiles: Tab;
    tabEquipAlerts: Tab;
    tabEquipment: Tab;
    tabFuelCards: Tab;
    tabGeneral: Tab;
    tabImage: Tab;
    tabLoadMatch: Tab;
    tabLogixSolutions: Tab;
    tabOSD: Tab;
    tabOperations: Tab;
    tabPerformance: Tab;
    tabProfiles: Tab;
    tabServiceIncidents: Tab;
    tableAccidents: Table;
    tableAutoHome: Table;
    tableAutoHomeHistory: Table;
    tableClaims: Table;
    tableDriverMiles: Table;
    tableLaneExclusions: Table;
    tableOSD: Table;
    tableServiceIncident: Table;
    tabsetAutoHome: Tabset;
    tabsetDriver: Tabset;
    tabsetPerformance: Tabset;
    textAddress: Textbox;
    textCity: CityState;
    textDolly1Id: Textbox;
    textDolly2Id: Textbox;
    textDriverPayee: Textbox;
    textFirstName: Textbox;
    textHireDate: Textbox;
    textId: Textbox;
    textLastName: Textbox;
    textLicenseExpirationDate: Textbox;
    textMVRDate: Textbox;
    textMidInitial: Textbox;
    textPhysicalDueDate: Textbox;
    textReviewDate: Textbox;
    textTractorId: Textbox;
    textTrailer2Id: Textbox;
    textTrailer3Id: Textbox;
    textTrailerId: Textbox;
    textboxActualArrivalSearch: Textbox;
    textboxActualDepartureSearch: Textbox;
    textboxAddressSearch: Textbox;
    textboxAvlAsOfDate: Textbox;
    textboxAvlDriveHours: Textbox;
    textboxAvlHours: Textbox;
    textboxAvlOndutyHours: Textbox;
    textboxBirthdate: Textbox;
    textboxCb: Textbox;
    textboxChoiceCommodity: Textbox;
    textboxChoiceCustomer: Textbox;
    textboxChoiceEquipType: Textbox;
    textboxChoiceOrderType: Textbox;
    textboxChoicePriority1: Textbox;
    textboxChoicePriority1Value: Textbox;
    textboxChoicePriority2: Textbox;
    textboxChoicePriority2Value: Textbox;
    textboxChoiceRevenue: Textbox;
    textboxChoiceReviewDt: Textbox;
    textboxDriverPtaDate: Textbox;
    textboxDrvrClass: Textbox;
    textboxEldExemptReasonId: Textbox;
    textboxEmrgResponseDate: Textbox;
    textboxEnginedataPwd: Textbox;
    textboxEventStatus: Textbox;
    textboxFleetManager: Textbox;
    textboxFmcsaClearinghouseDate: Textbox;
    textboxGroupId: Textbox;
    textboxHazmatDate: Textbox;
    textboxHm126cDate: Textbox;
    textboxHomeDuration: Textbox;
    textboxHomeLocationId: Textbox;
    textboxLast34HourStartDate: Textbox;
    textboxLastBreakDate: Textbox;
    textboxLastHomeDate: Textbox;
    textboxLastLocation: Textbox;
    textboxLicenseNo: Textbox;
    textboxLicenseState: Textbox;
    textboxLocationNameSearch: Textbox;
    textboxLogbookRequired: Switch;
    textboxMarylandPermDate: Textbox;
    textboxMcLogin: Textbox;
    textboxMcUnitPassword: Textbox;
    textboxMedicalCertExpire: Textbox;
    textboxMpwDriverContactMethod: Textbox;
    textboxMpwDriverHigh: Textbox;
    textboxMpwDriverLow: Textbox;
    textboxMpwLastContact: Textbox;
    textboxMpwNumAttempts: Textbox;
    textboxMpwNumOrders: Textbox;
    textboxNameOfSpouse: Textbox;
    textboxNextHomeDate: Textbox;
    textboxPTAOverride: Textbox;
    textboxPlanningComment: Textbox;
    textboxPreferredDaysOut: Textbox;
    textboxPrevCode: Textbox;
    textboxPtaDate: Textbox;
    textboxRace: Textbox;
    textboxReasonForLeaving: Textbox;
    textboxReturnHomeFlag: Textbox;
    textboxSecurityDate: Textbox;
    textboxSex: Textbox;
    textboxSiteId: Textbox;
    textboxSocialSecurityNo: Textbox;
    textboxStatusCode: Textbox;
    textboxTenstreetId: Textbox;
    textboxTerminationDate: Textbox;
}
